import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=613316cc&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=613316cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613316cc",
  null
  
)

export default component.exports